import {
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverContentProps,
  PopoverProps,
  PopoverTrigger,
  Portal,
  PortalProps,
  UseDisclosureReturn,
  useDisclosure,
  useMediaQuery
} from "@chakra-ui/react"
import { Fragment } from "react"

export type TooltipProps = {
  children: React.ReactNode
  title?: string | React.ReactNode
  fitContent?: boolean
  popover?: PopoverProps
  content?: PopoverContentProps
  disclosure?: UseDisclosureReturn
  portal?: Partial<PortalProps> | boolean
}

function Tooltip({
  children,
  title,
  fitContent,
  popover,
  content,
  disclosure: disclosureProp,
  portal = true
}: TooltipProps) {
  // Optionally force popover to fit width of content.
  // Otherwise, popover will render content at a max-width.
  const contentProps = fitContent
    ? {
        ...content,
        width: "auto",
        whiteSpace: "nowrap"
      }
    : content

  const disclosure = useDisclosure()
  // Control the popover to allow for closing the popover when clicking
  // the trigger.
  const { isOpen, onClose, onOpen } = disclosureProp || disclosure

  // Prevent tooltip entirely device does not have hover.
  const [hasHover] = useMediaQuery("(hover: hover)")

  const MaybePortal = portal ? Portal : Fragment
  const portalProps = portal === true ? {} : portal

  return title && hasHover ? (
    <Popover
      trigger="hover"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      closeOnBlur={popover?.trigger !== "click"}
      closeOnEsc
      returnFocusOnClose
      {...popover}
    >
      <PopoverTrigger>
        <HStack
          as="span"
          className="TooltipWrapper"
          onClick={popover?.trigger === "click" ? undefined : onClose}
          cursor={popover?.trigger === "click" ? "pointer" : undefined}
        >
          {children}
        </HStack>
      </PopoverTrigger>
      <MaybePortal {...portalProps}>
        <PopoverContent
          border="none"
          fontSize="14px"
          opacity="0.9"
          lineHeight="1.3"
          letterSpacing="1px"
          backgroundColor="black"
          color="whiteAlpha.900"
          p="5px"
          borderRadius="5px"
          boxShadow="0 0 10px 2px rgba(0, 0, 0, 0.2)"
          onClick={(e) => {
            e.stopPropagation()
          }}
          {...contentProps}
        >
          <PopoverArrow
            border="none"
            backgroundColor="black"
            shadowColor="black"
          />
          <PopoverBody>{title}</PopoverBody>
        </PopoverContent>
      </MaybePortal>
    </Popover>
  ) : (
    children
  )
}

export default Tooltip
